import React from 'react';
class TextInputWrap extends React.Component {
  

  render(){

    const inputType=this.props.type || "text"
    
      return (

        <div className="form-group">
            <p className="mg-b-10">{this.props.label}<span className="text-danger">{this.props.required?"*":""}</span></p>
            
            {inputType!=="textarea" &&
              <input 
                type={ inputType || "text" } 
                className="form-control" 
                placeholder={this.props.placeholder || this.props.label}
                onChange={this.props.onChange()}
                onClick={this.props.onClick}
                value={this.props.value}
                autoFocus={this.props.autoFocus}
                readOnly={this.props.readonly || false}/>}

                {inputType==="textarea" &&
                  <textarea 
                    type={ inputType } 
                    className="form-control" 
                    placeholder={this.props.label}
                    onChange={this.props.onChange()}
                    value={this.props.value}
                    onClick={this.props.onClick}
                    readOnly={this.props.readonly || false}/>}
            
            
            </div>
      );
    
 
  }
}

export default TextInputWrap;